/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CPUStat
 */
export interface CPUStat {
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    time: number;
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    cIdle: number;
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    cIowait: number;
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    cSystem: number;
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    cUser: number;
    /**
     * 
     * @type {number}
     * @memberof CPUStat
     */
    cUsage: number;
}

export function CPUStatFromJSON(json: any): CPUStat {
    return CPUStatFromJSONTyped(json, false);
}

export function CPUStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): CPUStat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'cIdle': json['c_idle'],
        'cIowait': json['c_iowait'],
        'cSystem': json['c_system'],
        'cUser': json['c_user'],
        'cUsage': json['c_usage'],
    };
}

export function CPUStatToJSON(value?: CPUStat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'c_idle': value.cIdle,
        'c_iowait': value.cIowait,
        'c_system': value.cSystem,
        'c_user': value.cUser,
        'c_usage': value.cUsage,
    };
}


